import axios from 'axios'
import FileSaver from "file-saver";
import * as XLSX from 'xlsx/xlsx.mjs'

export default {
    toPermissionTree: function(data) {
        let result = []
        if(!Array.isArray(data)) {
            return result
        }
        data.forEach(item => {
            delete item.children;
        });
        let map = {};
        data.forEach(item => {
            map[item.id] = item;
        });
        data.forEach(item => {
            let parent = map[item.pid];
            if(parent) {
                (parent.children || (parent.children = [])).push(item);
            } else {
                result.push(item);
            }
        });
        return result;
    },
    getDict:function (types){
        return axios.get('/codeDict/getDicts?types='+types).then(res => {
            return res.data.data;
        })
    },
    getTableMaxHeight: function (refDiv){
        return document.documentElement.clientHeight-92-refDiv.getBoundingClientRect().top
    },
    getDialogMaxHeight: function (refDiv){
        return document.documentElement.clientHeight-refDiv.getBoundingClientRect().top
    },
    exportExcel: function (tableId,sheetname){
        if(sheetname==null || sheetname==''){
            sheetname = 'sheet'
        }
        var xlsxParam = { raw: true };
        /* 从表生成工作簿对象 */
        var wb = XLSX.utils.table_to_book(
            document.querySelector("#"+tableId),
            xlsxParam
        );
        /* 获取二进制字符串作为输出 */
        var wbout = XLSX.write(wb, {
            bookType: "xlsx",
            bookSST: true,
            type: "array",
        });
        try {
            FileSaver.saveAs(
                //Blob 对象表示一个不可变、原始数据的类文件对象。
                //Blob 表示的不一定是JavaScript原生格式的数据。
                //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                new Blob([wbout], { type: "application/octet-stream" }),
                //设置导出文件名称
                sheetname+".xlsx"
            );
        } catch (e) {
            if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
    },
    disableElements: function (element, disabled) {
        //class中有no_disabled的跳过
        if(element.className.indexOf("no_disabled")>=0){
            element.style.pointerEvents = 'auto'
            return
        }
        // 若元素支持 disabled 属性，则设置其值
        if (element.disabled!== undefined) {
            element.disabled = disabled;
        }
        // 设置元素的 pointer-events 属性
        element.style.pointerEvents = disabled? 'none' : 'auto';
        // 递归处理子元素
        const children = element.children;
        for (let i = 0; i < children.length; i++) {
            this.disableElements(children[i], disabled);
        }
    }
}